import trim from "lodash/trim";
import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";
import { Flex } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useIsUnbiasedMode } from "PFCore/hooks";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Activity } from "PFTypes";

import css from "./wm_cell.module.scss";

type WmCellProps = {
  profile: ShortlistWithScores["profile"];
  activity: Activity;
};

export const WmCell = ({ profile, activity }: WmCellProps) => {
  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  const profileFullName = getUnbiasedProfileName(profile, isUnbiasedMode);
  const title = trim(`${profileFullName} ${isUnbiasedMode ? "" : profile.email}`);

  return (
    <Flex direction="column" justifyContent="start" gap={null} className={css.root} title={title}>
      <Typography withMargin variant="bodyBold" tag="span">
        {profileFullName}
      </Typography>
      {!isUnbiasedMode && (
        <Typography withMargin variant="labelRegular" tag="span" textOverflow="clip">
          {profile.email}
        </Typography>
      )}
    </Flex>
  );
};
